import { Injectable, ElementRef } from '@angular/core';
import { Language } from '../../shared/interfaces/language.interface';
import { Languages } from '../../shared/constants/shared.constants';
import { CustomerAccount } from '../models/customer-account.interface';
import { Store, StoreConfig } from '@datorama/akita';

export interface LayoutState {
   language: Language;
   customerAccount: CustomerAccount;
   customerAccounts: CustomerAccount[];
}

export function createInitialState(): LayoutState {
  return {
    language: Languages.find(lang => lang.isDefault)!,
    customerAccounts: [],
    customerAccount: {id: 0, customerName: '', customerNumber: 0, isDefault: false}
  };
}

@StoreConfig({ name: 'layout' })
@Injectable({providedIn: 'root'})
export class LayoutStore extends Store<LayoutState> {
  constructor() {
    super(createInitialState());
  }
}
